
type permissionType = 'Read' | 'Create' | 'Update' | 'Delete';

export const PERMISSIONS: {[key: string]: permissionType} = {
    'R': 'Read',
    'C': 'Create',
    'U': 'Update',
    'D': 'Delete',
};

export const DEFINED_ROLES: {[key: string]: {
    permissions: string[], groupId: string}} = {
    'R': {
        permissions: [PERMISSIONS.R],
        groupId: import.meta.env.VITE_USER_GROUP_ID_R ?
        import.meta.env.VITE_USER_GROUP_ID_R : ''
    },
    'RC': {
        permissions:[PERMISSIONS.R, PERMISSIONS.C],
        groupId: import.meta.env.VITE_USER_GROUP_ID_RC ?
        import.meta.env.VITE_USER_GROUP_ID_RC : ''
    },
    'RCU': {
        permissions:[PERMISSIONS.R, PERMISSIONS.C, PERMISSIONS.U],
        groupId: import.meta.env.VITE_USER_GROUP_ID_RCU ?
        import.meta.env.VITE_USER_GROUP_ID_RCU : ''
    },
    'RCD': {
        permissions:[PERMISSIONS.R, PERMISSIONS.C, PERMISSIONS.D],
        groupId: import.meta.env.VITE_USER_GROUP_ID_RCD ?
        import.meta.env.VITE_USER_GROUP_ID_RCD : ''
    },
    'RCUD': {
        permissions:[
            PERMISSIONS.R, PERMISSIONS.C, PERMISSIONS.U, PERMISSIONS.D],
        groupId: import.meta.env.VITE_USER_GROUP_ID_RCUD ?
        import.meta.env.VITE_USER_GROUP_ID_RCUD : ''
    },
    'RU': {
        permissions:[PERMISSIONS.R, PERMISSIONS.U],
        groupId: import.meta.env.VITE_USER_GROUP_ID_RU ?
        import.meta.env.VITE_USER_GROUP_ID_RU : ''
    },
    'RUD': {
        permissions:[PERMISSIONS.R, PERMISSIONS.U, PERMISSIONS.D],
        groupId: import.meta.env.VITE_USER_GROUP_ID_RUD ?
        import.meta.env.VITE_USER_GROUP_ID_RUD : ''
    },
    'RD': {
        permissions:[PERMISSIONS.R, PERMISSIONS.D],
        groupId: import.meta.env.VITE_USER_GROUP_ID_RD ?
        import.meta.env.VITE_USER_GROUP_ID_RD : ''
    },
    'ARCUD': {
        permissions:['Admin', PERMISSIONS.R, PERMISSIONS.C, PERMISSIONS.U, PERMISSIONS.D],
        groupId: import.meta.env.VITE_USER_GROUP_ID_ARCUD ?
        import.meta.env.VITE_USER_GROUP_ID_ARCUD : ''
    },
};

export const SELECT_PLACEHOLDER = 'Select Role';